// extracted by mini-css-extract-plugin
export default {"footerImg":"style_footerImg__aaFUn","footerP":"style_footerP__hO51M"};